import { type AddHookResponse, mutationAdd } from '../hooks'
import { toResponseError, type ConversationCreateInput, type ConversationCreateSuccess } from '@terros/common'
import { useTantalimMutation } from '../mutation'

export function useCreateConversation(): AddHookResponse<ConversationCreateInput, ConversationCreateSuccess> {
  const mutation = useTantalimMutation<ConversationCreateInput, ConversationCreateSuccess>({
    url: '/conversation/create',
  })

  async function add(input: ConversationCreateInput): Promise<ConversationCreateSuccess> {
    try {
      const res = await mutation.mutateAsync(input)
      return res
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
